import React from "react";
import { connect } from "react-redux";
import { fetchMeetUsers } from "../../../invite/functions";
import { getSortedParticipantIds } from "../../functions";
import { iAmVisitor } from "../../../visitors/functions";
import AbstractAddPeopleDialog, { _mapStateToProps as _abstractMapStateToProps, } from "../../../../features/invite/components/add-people-dialog/AbstractAddPeopleDialog";
import { getParticipantById } from "../../../base/participants/functions";
import { hideAddPeopleDialog } from "../../../invite/actions.any";
import { translate } from "../../../base/i18n/functions";
import { getCurrentRoomId } from "../../../breakout-rooms/functions";
import Collapse from "../../../base/components/collapse/collapse";
import Avatar from "../../../base/avatar/components/Avatar";
import Text from "../../../base/react/components/web/Text";
class AbsentParticipants extends AbstractAddPeopleDialog {
    state = {
        addToCallError: false,
        addToCallInProgress: false,
        inviteItems: [],
        loading: false,
        users: [],
        callingUserId: null,
    };
    constructor(props) {
        super(props);
        this._onInviteClick = this._onInviteClick.bind(this);
    }
    async componentDidMount() {
        const { _jwt, _currentRoomId, _meetApiUrl } = this.props;
        try {
            const users = (await fetchMeetUsers(_jwt, _currentRoomId, _meetApiUrl));
            this.setState({ users, loading: false });
        }
        catch (err) {
            console.error("Error fetching meet users:", err);
            this.setState({ loading: false });
        }
    }
    _onInviteClick(user) {
        this.setState({ callingUserId: user.id });
        setTimeout(() => this.setState({ callingUserId: null }), 5000);
        const invitee = {
            name: user.name,
            id: user.id,
            type: "user",
        };
        this._invite([invitee])
            .then((invitesLeftToSend) => {
            console.log("invitesLeftToSend", invitesLeftToSend);
        })
            .finally(() => this.props.dispatch(hideAddPeopleDialog()));
    }
    render() {
        const { users, loading, callingUserId } = this.state;
        const { sortedParticipants, t, _currentRoomId } = this.props;
        const absentParticipants = users.filter((user) => !sortedParticipants.some((participant) => participant?.email === user.id));
        return (React.createElement("div", { className: "absentParticipants-wrapper" }, absentParticipants && absentParticipants?.length > 0 && !loading ? (React.createElement(Collapse, { header: `${t("addPeople.peopleAddedToMeet")} (${absentParticipants && absentParticipants?.length})`, defaultOpen: true }, absentParticipants?.length > 0
            ? absentParticipants.map((user) => (React.createElement("div", { key: user.id, className: "absentParticipants-list-item" },
                React.createElement("div", { className: "gap-4 d-flex align-items-center " },
                    React.createElement(Avatar, { displayName: user?.fullName, size: 32 }),
                    React.createElement(Text, { className: "text-ellipsis overflow-hidden no-wrap", style: { maxWidth: 100 } }, user?.fullName)),
                callingUserId === user.id ? (React.createElement("span", null, t("prejoin.calling"))) : (React.createElement("button", { className: "nx-button transparent", onClick: () => this._onInviteClick(user) }, t("addPeople.inviteToMeet"))))))
            : null)) : null));
    }
}
function _mapStateToProps(state) {
    let sortedParticipants = getSortedParticipantIds(state);
    const _iAmVisitor = iAmVisitor(state);
    const _currentRoomId = getCurrentRoomId(state);
    const _meetApiUrl = state["features/base/config"].meetApiUrl;
    sortedParticipants = sortedParticipants.map((id) => {
        const participant = getParticipantById(state, id);
        if (_iAmVisitor && participant?.local) {
            return false;
        }
        return participant;
    });
    return {
        sortedParticipants,
        _currentRoomId,
        _meetApiUrl,
        ..._abstractMapStateToProps(state),
    };
}
export default translate(connect(_mapStateToProps)(AbsentParticipants));
